import { useEffect, useState } from "react";

// useState that remembers its value in this browser between visits.
export function useSavedState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(`breathtones:${key}`);
      return raw === null ? initial : JSON.parse(raw);
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(`breathtones:${key}`, JSON.stringify(value));
    } catch {
      /* storage unavailable (private mode) */
    }
  }, [key, value]);
  return [value, setValue];
}
